module.exports = __webpack_public_path__ + "static/media/signin.51dac6c4.svg";